import { BookConditions } from '@hermes/types'

enum SortTypes {
  SCORE = 'SCORE',
  PRICE = 'PRICE'
}

export enum DeliveryMethodFilterTypes {
  DELIVERY_METHOD_SHIPPING = 'DELIVERY_METHOD_SHIPPING',
  DELIVERY_METHOD_MEETUP = 'DELIVERY_METHOD_MEETUP'
}
export enum ConditionFilterTypes {
  CONDITION_LIKE_NEW = 'CONDITION_LIKE_NEW',
  CONDITION_VERY_GOOD = 'CONDITION_VERY_GOOD',
  CONDITION_GOOD = 'CONDITION_GOOD',
  CONDITION_ACCEPTABLE = 'CONDITION_ACCEPTABLE',
  CONDITION_REFURBISHED = 'CONDITION_REFURBISHED'
}

export type SortField = {
  label: string
  active: boolean
  type: keyof typeof SortTypes
  value: 'price' | 'score'
}

type BaseFilterField = {
  label: string
  active: boolean
}
export type DeliveryMethodFilterField = BaseFilterField & {
  category: 'DELIVERY_METHOD'
  type: keyof typeof DeliveryMethodFilterTypes
  value: 'shipping' | 'meetup'
}

export type ConditionFilterField = BaseFilterField & {
  category: 'CONDITION'
  type: keyof typeof ConditionFilterTypes
  value: BookConditions
}

export type FilterData = {
  DELIVERY_METHOD: { title: string; options: Array<DeliveryMethodFilterField> }
  CONDITION: { title: string; options: Array<ConditionFilterField> }
}
export type SortData = SortField[]
export enum ModalTypes {
  SORT = 'SORT',
  FILTER = 'FILTER'
}
